import { createAsyncThunk } from "@reduxjs/toolkit";
import { getContractNoteProcess } from "../../../helpers/fakebackend_helper";



export const contractNote_processThunk = createAsyncThunk("contractNote_processThunk", async ({ params, token }, { rejectWithValue } ) => {
  try {
    const response = await getContractNoteProcess( params, token);
    return response;
  } catch (error) {
    // Properly pass the error structure to the reducer
    return rejectWithValue({
      code: error.data?.code || error.code,
      message: error.message,
      data: error.data
    });
  }
});










